import React from "react";

const DevicesIcon = props => {
  const color = props.color;
  return (
    <svg width={24} height={22} {...props}>
      <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <path
          d="M22.657 9V1.69c0-.931-.766-1.69-1.72-1.69H1.969A1.7 1.7 0 0 0 .262 1.69v10.064c0 .932.765 1.691 1.72 1.691h8.18l-.376 1.253a1.222 1.222 0 0 0-.68-.206H1.22c-.673 0-1.22.543-1.22 1.21v3.666c0 .667.547 1.21 1.22 1.21h7.887c.673 0 1.22-.543 1.22-1.21v-.236h4.127v1.659c0 .667.548 1.209 1.22 1.209h7.106c.673 0 1.22-.542 1.22-1.209V10.21C24 9.543 23.453 9 22.78 9h-.123zm.53 1.21v9.047h-7.92V10.21c0-.222.183-.404.407-.404h7.106c.224 0 .406.182.406.404zm-8.733 4.165V16.338l-.315-.062a.891.891 0 0 1-.692-.659l-.533-2.172h1.54v.93zM1.968.805h18.983a.89.89 0 0 1 .893.886V9h-6.17c-.622 0-1.131.466-1.205 1.064H1.076V1.69c0-.489.4-.885.892-.885zm0 11.834a.89.89 0 0 1-.893-.885v-.884h13.38v1.769H1.967zM.814 19.37v-3.667c0-.222.182-.403.406-.403h6.72v4.473H1.22a.406.406 0 0 1-.406-.403zm8.7 0a.406.406 0 0 1-.406.403h-.355v-4.473h.355c.224 0 .406.181.406.403v3.667zm.813-1.042v-2.625c0-.056-.009-.11-.016-.163a.392.392 0 0 0 .126-.178l.575-1.916h1.066l.58 2.363c.156.637.675 1.13 1.322 1.259l.474.094v1.166h-4.127zm12.454 2.868h-7.107a.406.406 0 0 1-.406-.404v-.728h7.919v.728a.406.406 0 0 1-.406.404z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <g transform="translate(0.000000, 2.000000)">
          <rect fill={color} x={0} y={13} width={9} height={5} rx={1} />
          <rect fill={color} x={15} y={7} width={9} height={11} rx={1} />
          <polyline
            stroke={color}
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="3 7 6 2 8 6 10 3 12 6 15 0 17 3 21 3"
          />
        </g>
      </g>
    </svg>
  );
};
export default DevicesIcon;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuIcons/DevicesIcon.js